import $ from 'jquery';
import Backbone from 'backbone';
import _ from 'underscore';
import ko from 'knockout';
import { odata } from '@bingads-webui/http-util';
import { Popup, PositionAttribute, showPopup } from '@bingads-webui-campaign/popup';
import tmpl from './template/urlTestTool.pug';
import ViewModel from './viewmodel';
import urlTestToolStatusTemplate from './template/urlTestToolStatus.pug';
import urlTestResultTemplate from './template/urlTestResult.pug';
import urlTestResultSummaryTemplateV2 from './template/urlTestResultSummaryV2.pug';
import urlTestResultListSummaryTemplateV2 from './template/urlTestResultListSummaryV2.pug';

const ResultTypes = [
  'UURLTestTool_Result_Found',
  'UURLTestTool_Result_NotFound',
  'UURLTestTool_Result_Mismatch',
  'UURLTestTool_Result_Unreachable',
  'UURLTestTool_Result_Unknown',
  'UURLTestTool_Result_UserInputError',
  'UURLTestTool_Result_NoEligibleUrlsFound',
  'UURLTestTool_Result_TestComplete',
];

const TrackingResultTypes = [
  'UURLTestTool_TrackingCall_Successful',
  'UURLTestTool_TrackingCall_Unsuccessful',
];

const LevelTypes = [
  'Unkown',
  'Entity_Account',
  'Entity_Campaign',
  'Entity_Adgroup',
  'Entity_Ads',
  'Entity_Keywords',
  'Entity_SitelinkExtensions',
];

const TestingItemMapping = {
  ptLandingUrl: 'ptLandingUrl',
  ptTrackingUrl: 'ptTrackingUrl',
  sqServingUrl: 'sqServingUrl',
};

function getLevelString(level, i18n) {
  return level === 0 ? null : i18n.getString('UURLTestTool_From').replace('{0}', i18n.getString(LevelTypes[level]));
}

function normalizeUurlTestResult(rawResult, i18n) {
  if (_.isUndefined(rawResult)) {
    return rawResult;
  }

  let attributes = _.union(
    _.map(rawResult.CustomParameters, parameter => ({
      Key: `{_${parameter.Key}}`,
      Value: parameter.Value,
      Level: getLevelString(parameter.Level, i18n),
    })),
    _.map(rawResult.ValueTrackParameters, parameter => ({
      Key: `{${parameter.Key}}`,
      Value: parameter.Value,
      Level: null,
    })),
    _.map(rawResult.IndicateParameters, parameter => ({
      Key: parameter.Key,
      Value: parameter.Value,
      Level: null,
    }))
  );

  if (rawResult.LpUrl) {
    attributes = _.union([{
      Key: `{${rawResult.LpUrl.Key}}`,
      Value: rawResult.LpUrl.Value,
      Level: getLevelString(rawResult.LpUrl.Level, i18n),
    }], attributes);
  }

  let result = {
    resultType: rawResult.Result,
    resultString: i18n.getString(ResultTypes[rawResult.Result]),
    servingUrl: rawResult.ServingUrl,
    landingUrl: rawResult.LandingUrl,
    attributes,
  };

  if (rawResult.TrackingTemplate) {
    const trackingTemplate = {
      Value: rawResult.TrackingTemplate.Value,
      Level: getLevelString(rawResult.TrackingTemplate.Level, i18n),
    };
    result = _.extend(result, {
      trackingTemplate,
    });
  }

  if (rawResult.FinalUrl) {
    const finalUrl = {
      Value: rawResult.FinalUrl.Value,
      Level: getLevelString(rawResult.FinalUrl.Level, i18n),
    };
    result = _.extend(result, {
      finalUrl,
    });
  }

  if (rawResult.FinalUrlSuffix) {
    const finalUrlSuffix = {
      Value: rawResult.FinalUrlSuffix.Value,
      Level: getLevelString(rawResult.FinalUrlSuffix.Level, i18n),
    };
    result = _.extend(result, {
      finalUrlSuffix,
    });
  }

  if (rawResult.ParallelTrackingUrl) {
    const trackingUrl = {
      Value: rawResult.ParallelTrackingUrl.Value,
      Level: getLevelString(rawResult.ParallelTrackingUrl.Level, i18n),
    };
    result = _.extend(result, {
      trackingUrl,
    });
  }

  if (!_.isNull(rawResult.TrackingCallResult) && !_.isUndefined(rawResult.TrackingCallResult)) {
    result = _.extend(result, {
      trackingResultType: rawResult.TrackingCallResult,
      trackingResultString: i18n.getString(TrackingResultTypes[rawResult.TrackingCallResult]),
    });
  }

  return result;
}

let detailPopup = null;

export class UrlTestTool extends Backbone.View {
  initialize({
    token,
    triggerTestUurl,
    instrumentation,
    i18n,
  }) {
    this.options = {
      token,
      triggerTestUurl,
      instrumentation,
      i18n,
      template: tmpl,
      isForVNext: true,
      location: 'topRight',
      position: PositionAttribute.fixed,
    };

    this.ko_model = new ViewModel();
  }

  get events() {
    return {
      'click .testUurl': 'testUurl',
      'click .resultDetails': 'showResultV2',
      'click .resultString': 'showResultDetailsForVNext',
      'mouseover .resultString': 'showResultDetailsForVNext',
    };
  }

  get attributes() {
    return {
      class: this.options && this.options.urlTestToolStatusContainer ? 'uurl-test-tool-inline' : '',
    };
  }

  render() {
    const useDefaultStatusContainer = !this.options.urlTestToolStatusContainer;
    const self = this;
    const popupSelector = `.popup--uurl-v2-${this.cid}`;

    this.$el.html($(tmpl({
      i18n: this.options.i18n,
      useDefaultStatusContainer,
    })));

    ko.cleanNode($(this.$('input.testUurl'))[0]);
    ko.applyBindings(this.ko_model, $(this.$('input.testUurl'))[0]);

    const urlTestToolStatusContainer = this.options.urlTestToolStatusContainer || this.$('.uurl-test-info__container');

    urlTestToolStatusContainer.empty()
      .append($(urlTestToolStatusTemplate({
        i18n: this.options.i18n,
        isForVNext: this.options.isForVNext,
      })));

    ko.cleanNode(urlTestToolStatusContainer[0]);
    ko.applyBindings(this.ko_model, urlTestToolStatusContainer[0]);

    if (!useDefaultStatusContainer) {
      urlTestToolStatusContainer.on('click', '.resultDetails', this.showResultV2.bind(this));
      urlTestToolStatusContainer.on('mouseover', '.resultString', this.showResultDetailsForVNext.bind(this));
    }

    // stopPropagation to prevent the tracking template inline editor from being closed
    $('body')
      .off('click', '.popup--uurl-v2')
      .on('click', '.popup--uurl-v2', (e) => {
        const $target = $(e.target);

        if (!$target.hasClass('HelpTopic')) {
          e.stopPropagation();
        }

        if ($target.closest('.popup--uurl-detail').length === 0) {
          self.dismissDetailPopup();
        }
      });

    $('body')
      .off('click', '.popup--uurl-v2 [data-toggle="collapse"]')
      .on('click', '.popup--uurl-v2 [data-toggle="collapse"]', (e) => {
        const curr = $(e.target);
        const parent = curr.parent(curr.attr('data-target'));
        const hasIn = parent.hasClass('in');
        const target = $(`[aria-expanded="${!hasIn}"]${curr.attr('data-target')}`);

        parent.toggleClass('in').attr('aria-expanded', !hasIn).height(hasIn ? '0' : 'auto');
        target.toggleClass('in').attr('aria-expanded', hasIn).height(!hasIn ? '0' : 'auto');
      });

    $('body')
      .off('click', `${popupSelector} .ptLandingUrl`)
      .on('click', `${popupSelector} .ptLandingUrl`, (e) => {
        self.showResultUrlDetailV2(e, TestingItemMapping.ptLandingUrl);
        e.stopPropagation();
      });

    $('body')
      .off('click', `${popupSelector} .ptTrackingUrl`)
      .on('click', `${popupSelector} .ptTrackingUrl`, (e) => {
        self.showResultUrlDetailV2(e, TestingItemMapping.ptTrackingUrl);
        e.stopPropagation();
      });

    $('body')
      .off('click', `${popupSelector} .sqServingUrl`)
      .on('click', `${popupSelector} .sqServingUrl`, (e) => {
        self.showResultUrlDetailV2(e, TestingItemMapping.sqServingUrl);
        e.stopPropagation();
      });

    return this;
  }

  remove() {
    ko.cleanNode(this.el);
    return this;
  }

  fetchAccountFinalUrlSuffix() {
    const select = '$select=FinalUrlSuffix';
    const url = `/ODataApi/Campaign/V2/Customers(${window.App.state.get('advertisercustomer_id')})/Accounts(${window.App.state.get('account_id')})?${select}`;
    return odata.get(url, {
      headers: {
        Authorization: `CCMTSmallToken ${this.options.token}`,
      },
    })
      .then(response => response.FinalUrlSuffix)
      .catch((err) => {
        if (this.options.instrumentation.logError) {
          // TODO: update instrumentation
          this.options.instrumentation.logError('/Campaign/TestUurl/', `Failed on url ${url}: ${JSON.stringify(err)}`);
        }
      });
  }

  testUurl() {
    const self = this;

    this.fetchAccountFinalUrlSuffix().then((res) => {
      this.ko_model.showTesting(true);
      this.ko_model.resultString(null);
      this.ko_model.resultType(null);
      this.options.triggerTestUurl(
        self.handleTestResultList,
        _.extend(self, { isParallelTracking: true, accountFinalUrlSuffix: res })
      );
    });
  }

  getTestStatus() {
    return {
      resultType: this.ko_model.resultType(),
      resultString: this.ko_model.resultString(),
      showTesting: this.ko_model.showTesting(),
    };
  }

  handleTestResultList(rawResultList) {
    this.ko_model.showTesting(false);

    if (!rawResultList) {
      return;
    }

    if (rawResultList.Result && rawResultList.Errors && rawResultList.Errors.length) {
      this.ko_model.resultType(rawResultList.Result);
      this.ko_model.resultString(this.options.i18n.getString(ResultTypes[rawResultList.Result]));
      return;
    }

    if (!_.isArray(rawResultList) || !rawResultList.length) {
      return;
    }

    this.urlTestResultList = [];
    this.isMultipleResult = rawResultList.isMultipleResult;
    this.resultListTrackingTemplate = rawResultList.resultListTrackingTemplate;
    const self = this;

    _.each(rawResultList, (rawResult) => {
      if (!rawResult) {
        return;
      }

      const normalizedResult = {
        sequentialTrackingResult: normalizeUurlTestResult(_.extend(
          {},
          { Result: rawResultList.Result },
          rawResult.SequentialTrackingResult
        ), this.options.i18n),
        parallelTrackingResult: rawResult.ParallelTrackingResult ?
          normalizeUurlTestResult(_.extend(
            {},
            { Result: rawResultList.Result },
            rawResult.ParallelTrackingResult
          ), this.options.i18n)
          : null,
        campaignName: rawResult.CampaignName,
        adGroupName: rawResult.AdGroupName,
      };

      if (!self.ko_model.resultType()) {
        self.calculateResultType(normalizedResult);
      }

      self.urlTestResultList.push(normalizedResult);
    });

    // For account/campaign level test that tests multiple ads/keywords/sitelinks,
    // we show Test complete as result string
    if (rawResultList.Result === 7) {
      this.ko_model.resultString(this.options.i18n.getString(ResultTypes[rawResultList.Result]));
    }
  }

  calculateResultType(urlTestResult) {
    const { sequentialTrackingResult, parallelTrackingResult } = urlTestResult;
    const isParallelTracking = !!parallelTrackingResult;

    if (isParallelTracking && parallelTrackingResult.resultType !== 0) {
      this.ko_model.resultType(parallelTrackingResult.resultType);
      this.ko_model.resultString(parallelTrackingResult.resultString);
    } else if (isParallelTracking && parallelTrackingResult.trackingResultType !== 0) {
      this.ko_model.resultType(parallelTrackingResult.trackingResultType);
      this.ko_model.resultString(parallelTrackingResult.trackingResultString);
    } else {
      this.ko_model.resultType(sequentialTrackingResult.resultType);
      this.ko_model.resultString(sequentialTrackingResult.resultString);
    }
  }

  createResultItemV2(result) {
    const sq = result.sequentialTrackingResult || {};
    const pt = result.parallelTrackingResult || {};
    const item = {
      sq: {
        resultType: sq.resultType,
        resultString: sq.resultString,
        landingUrl: sq.landingUrl,
        servingUrl: sq.servingUrl,
        finalUrl: sq.finalUrl,
        attributes: sq.attributes,
        trackingTemplate: sq.trackingTemplate,
        finalUrlSuffix: sq.finalUrlSuffix,
      },
      pt: {
        resultType: pt.resultType,
        resultString: pt.resultString,
        landingUrl: pt.landingUrl,
        servingUrl: pt.servingUrl,
        finalUrl: pt.finalUrl,
        attributes: pt.attributes,
        trackingTemplate: pt.trackingTemplate,
        finalUrlSuffix: pt.finalUrlSuffix,
        trackingUrl: pt.trackingUrl,
        trackingResultType: pt.trackingResultType,
        trackingResultString: pt.trackingResultString,
      },
      campaignName: result.campaignName,
      adGroupName: result.adGroupName || this.options.i18n.getString('UURLTestTool_NA'),
    };

    return item;
  }

  showResultV2(event) {
    if (this.isMultipleResult) {
      this.showResultListV2(event);
    } else {
      this.showResultSingleV2(event);
    }
  }

  showResultSingleV2(event) {
    if (!this.urlTestResultList || !this.urlTestResultList.length) {
      return;
    }

    const self = this;

    const result = this.createResultItemV2(this.urlTestResultList[0]);

    showPopup(_.extend(
      { i18n: this.options.i18n },
      {
        positioningMethod: 'fixed',
        positioningOptions: {
          location: this.options.location,
          positionAttribute: this.options.position,
        },
        classes: ['popup--uurl-v2', `popup--uurl-v2-${this.cid}`],
        template() {
          return urlTestResultSummaryTemplateV2({
            sq: result.sq,
            pt: result.pt,
            i18n: self.options.i18n,
          });
        },
      },
      {
        container: $('body'), // Move container to body otherwise it may overlapped by page menu
        anchor: $(event.target),
      }
    ));

    // Fix the help topic position issue in legacy UI
    if (!this.options.isForVNext) {
      _.defer(() => {
        const $popupUurlV2 = $('.popup--uurl-v2');
        $popupUurlV2.css('marginTop', `${$popupUurlV2[0].offsetHeight / (-2)}px`);
      });
    }
  }

  showResultListV2(event) {
    const resultList = [];
    const self = this;

    _.each(this.urlTestResultList, (result) => {
      resultList.push(this.createResultItemV2(result));
    });

    showPopup(_.extend(
      { i18n: this.options.i18n },
      {
        positioningMethod: 'fixed',
        positioningOptions: {
          location: this.options.location,
          positionAttribute: this.options.position,
        },
        classes: ['popup--uurl-v2', `popup--uurl-v2-${this.cid}`],
        // eslint-disable-next-line func-names
        template: function () {
          return urlTestResultListSummaryTemplateV2({
            resultList,
            resultListTrackingTemplate: this.resultListTrackingTemplate,
            i18n: self.options.i18n,
          });
        }.bind(this),
      },
      {
        container: $('body'),
        anchor: $(event.target),
      }
    ));

    // Fix the help topic position issue in legacy UI
    if (!this.options.isForVNext) {
      _.defer(() => {
        const $popupUurlV2 = $('.popup--uurl-v2');
        $popupUurlV2.css('marginTop', `${$popupUurlV2[0].offsetHeight / (-2)}px`);
      });
    }
  }

  showResultDetailsForVNext(event) {
    if (this.options.isForVNext) {
      this.showResultV2(event);
    }
  }

  // Show the popup for the details of testing result of certain url of V2
  showResultUrlDetailV2(event, testingItem) {
    const index = $(event.target).data('index') || 0;
    const result = this.urlTestResultList[index];

    if (!result) {
      return;
    }

    const sq = result.sequentialTrackingResult;
    const pt = result.parallelTrackingResult;
    const trackingResult = testingItem === TestingItemMapping.sqServingUrl ? sq : pt;
    const {
      finalUrl, trackingTemplate, finalUrlSuffix, attributes,
    } = trackingResult;

    this.dismissDetailPopup();
    detailPopup = new Popup({
      i18n: this.options.i18n,
    });
    detailPopup.show(_.extend(
      {
        i18n: this.options.i18n,
      },
      {
        positioningMethod: 'fixed',
        positioningOptions: {
          location: this.calculateDetailPopupLocation($(event.target)),
        },
        classes: ['popup--uurl-detail'],
        template() {
          return urlTestResultTemplate({
            finalUrl,
            attributes,
            trackingTemplate,
            finalUrlSuffix,
            i18n: this.i18n,
            index: 0,
          });
        },
      },
      {
        container: $('.popup.popup--uurl-v2'),
        anchor: $(event.target),
      }
    ));
  }

  calculateDetailPopupLocation(anchor) {
    const windowHeight = $(window).height();
    const anchorTop = anchor[0].getBoundingClientRect().top;
    const anchorHeight = anchor.outerHeight();

    if (windowHeight - anchorHeight - anchorTop > 400) {
      return 'buttomRight';
    }

    return 'topRight';
  }

  dismissDetailPopup() {
    if (detailPopup) {
      detailPopup.dismiss();
      detailPopup = null;
    }
  }
}

